"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2.default)(),
      spacing = _useTheme.spacing,
      colors = _useTheme.colors,
      breakpoint = _useTheme.breakpoint;

  return {
    root: (0, _defineProperty2.default)({
      backgroundColor: colors.pageBackground,
      paddingTop: spacing(4)
    }, breakpoint.up('md'), {
      paddingBottom: spacing(5)
    }),
    content: {
      width: '100%',
      maxWidth: breakpoint.values.xl,
      padding: spacing(0, 4),
      display: 'flex',
      justifyContent: 'flex-end',
      flexWrap: 'wrap',
      overflow: 'hidden'
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing, colors, breakpoint }}", function () {
  return [_useTheme2.default];
});

var Footer = function Footer(props) {
  var children = props.children,
      flexProps = (0, _objectWithoutProperties2.default)(props, ["children"]);
  var classes = useStyles();
  return (0, _core.jsx)(_Flex.default, (0, _extends2.default)({
    css: classes.root,
    justifyContent: "center"
  }, flexProps), (0, _core.jsx)("footer", {
    css: classes.content
  }, children));
};

__signature__(Footer, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Footer;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/index.tsx");
  reactHotLoader.register(Footer, "Footer", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Footer/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Gb290ZXIvaW5kZXgudHN4Il0sIm5hbWVzIjpbInVzZVN0eWxlcyIsInNwYWNpbmciLCJjb2xvcnMiLCJicmVha3BvaW50Iiwicm9vdCIsImJhY2tncm91bmRDb2xvciIsInBhZ2VCYWNrZ3JvdW5kIiwicGFkZGluZ1RvcCIsInVwIiwicGFkZGluZ0JvdHRvbSIsImNvbnRlbnQiLCJ3aWR0aCIsIm1heFdpZHRoIiwidmFsdWVzIiwieGwiLCJwYWRkaW5nIiwiZGlzcGxheSIsImp1c3RpZnlDb250ZW50IiwiZmxleFdyYXAiLCJvdmVyZmxvdyIsInVzZVRoZW1lIiwiRm9vdGVyIiwicHJvcHMiLCJjaGlsZHJlbiIsImZsZXhQcm9wcyIsImNsYXNzZXMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUVBOztBQUVBOzs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsU0FBUyxHQUFHLFNBQVpBLFNBQVksR0FBTTtBQUFBLGtCQUNrQix5QkFEbEI7QUFBQSxNQUNkQyxPQURjLGFBQ2RBLE9BRGM7QUFBQSxNQUNMQyxNQURLLGFBQ0xBLE1BREs7QUFBQSxNQUNHQyxVQURILGFBQ0dBLFVBREg7O0FBRXRCLFNBQU87QUFDTEMsSUFBQUEsSUFBSTtBQUNGQyxNQUFBQSxlQUFlLEVBQUVILE1BQU0sQ0FBQ0ksY0FEdEI7QUFFRkMsTUFBQUEsVUFBVSxFQUFFTixPQUFPLENBQUMsQ0FBRDtBQUZqQixPQUdERSxVQUFVLENBQUNLLEVBQVgsQ0FBYyxJQUFkLENBSEMsRUFHcUI7QUFDckJDLE1BQUFBLGFBQWEsRUFBRVIsT0FBTyxDQUFDLENBQUQ7QUFERCxLQUhyQixDQURDO0FBUUxTLElBQUFBLE9BQU8sRUFBRTtBQUNQQyxNQUFBQSxLQUFLLEVBQUUsTUFEQTtBQUVQQyxNQUFBQSxRQUFRLEVBQUVULFVBQVUsQ0FBQ1UsTUFBWCxDQUFrQkMsRUFGckI7QUFHUEMsTUFBQUEsT0FBTyxFQUFFZCxPQUFPLENBQUMsQ0FBRCxFQUFJLENBQUosQ0FIVDtBQUlQZSxNQUFBQSxPQUFPLEVBQUUsTUFKRjtBQUtQQyxNQUFBQSxjQUFjLEVBQUUsVUFMVDtBQU1QQyxNQUFBQSxRQUFRLEVBQUUsTUFOSDtBQU9QQyxNQUFBQSxRQUFRLEVBQUU7QUFQSDtBQVJKLEdBQVA7QUFrQkQsQ0FwQkQ7O2NBQU1uQixTO1VBQ29Db0Isa0I7OztBQXFCMUMsSUFBTUMsTUFBeUIsR0FBRyxTQUE1QkEsTUFBNEIsQ0FBQ0MsS0FBRCxFQUFXO0FBQUEsTUFDbkNDLFFBRG1DLEdBQ1JELEtBRFEsQ0FDbkNDLFFBRG1DO0FBQUEsTUFDdEJDLFNBRHNCLDBDQUNSRixLQURRO0FBRzNDLE1BQU1HLE9BQU8sR0FBR3pCLFNBQVMsRUFBekI7QUFFQSxTQUNFLGVBQUMsYUFBRDtBQUFNLElBQUEsR0FBRyxFQUFFeUIsT0FBTyxDQUFDckIsSUFBbkI7QUFBeUIsSUFBQSxjQUFjLEVBQUM7QUFBeEMsS0FBcURvQixTQUFyRCxHQUNFO0FBQVEsSUFBQSxHQUFHLEVBQUVDLE9BQU8sQ0FBQ2Y7QUFBckIsS0FBK0JhLFFBQS9CLENBREYsQ0FERjtBQUtELENBVkQ7O2NBQU1GLE07VUFHWXJCLFM7OztlQVNIcUIsTTs7Ozs7Ozs7Ozs7OzBCQWxDVHJCLFM7MEJBc0JBcUIsTSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBGdW5jdGlvbkNvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IEZsZXggZnJvbSAnLi4vRmxleCc7XG5cbmltcG9ydCB1c2VUaGVtZSBmcm9tICcuLi9zdHlsZXMvdXNlVGhlbWUnO1xuXG5jb25zdCB1c2VTdHlsZXMgPSAoKSA9PiB7XG4gIGNvbnN0IHsgc3BhY2luZywgY29sb3JzLCBicmVha3BvaW50IH0gPSB1c2VUaGVtZSgpO1xuICByZXR1cm4ge1xuICAgIHJvb3Q6IHtcbiAgICAgIGJhY2tncm91bmRDb2xvcjogY29sb3JzLnBhZ2VCYWNrZ3JvdW5kLFxuICAgICAgcGFkZGluZ1RvcDogc3BhY2luZyg0KSxcbiAgICAgIFticmVha3BvaW50LnVwKCdtZCcpXToge1xuICAgICAgICBwYWRkaW5nQm90dG9tOiBzcGFjaW5nKDUpLFxuICAgICAgfSxcbiAgICB9LFxuICAgIGNvbnRlbnQ6IHtcbiAgICAgIHdpZHRoOiAnMTAwJScsXG4gICAgICBtYXhXaWR0aDogYnJlYWtwb2ludC52YWx1ZXMueGwsXG4gICAgICBwYWRkaW5nOiBzcGFjaW5nKDAsIDQpLFxuICAgICAgZGlzcGxheTogJ2ZsZXgnLFxuICAgICAganVzdGlmeUNvbnRlbnQ6ICdmbGV4LWVuZCcsXG4gICAgICBmbGV4V3JhcDogJ3dyYXAnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgIH0sXG4gIH0gYXMgY29uc3Q7XG59O1xuXG5jb25zdCBGb290ZXI6IEZ1bmN0aW9uQ29tcG9uZW50ID0gKHByb3BzKSA9PiB7XG4gIGNvbnN0IHsgY2hpbGRyZW4sIC4uLmZsZXhQcm9wcyB9ID0gcHJvcHM7XG5cbiAgY29uc3QgY2xhc3NlcyA9IHVzZVN0eWxlcygpO1xuXG4gIHJldHVybiAoXG4gICAgPEZsZXggY3NzPXtjbGFzc2VzLnJvb3R9IGp1c3RpZnlDb250ZW50PVwiY2VudGVyXCIgey4uLmZsZXhQcm9wc30+XG4gICAgICA8Zm9vdGVyIGNzcz17Y2xhc3Nlcy5jb250ZW50fT57Y2hpbGRyZW59PC9mb290ZXI+XG4gICAgPC9GbGV4PlxuICApO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgRm9vdGVyO1xuIl19